import React from 'react';
import styles from './ThemCard.module.scss';
import { useBrandingContext } from 'app-context/BrandingsContext';
import { addOpacityToColor } from 'helpers/addOpacityToColor';
import { useFormikContext } from 'formik';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
const Card = ({ item, activeVoice, id, isCustom }) => {
  const formik = useFormikContext();
  const { brandingData } = useBrandingContext();
  const { page_ButtonColor } = brandingData;

  const handleChosenTheme = () => {
    formik.setFieldValue('responseThemeId', item[id]);
  };
  return (
    <div
      className={styles.card}
      style={{
        borderColor:
          activeVoice == item[id] || formik?.values?.responseThemeId == item[id]
            ? addOpacityToColor(page_ButtonColor)
            : '',
        backgroundColor:
          activeVoice == item[id] || formik?.values?.responseThemeId == item[id]
            ? addOpacityToColor(page_ButtonColor)
            : '',
      }}
      onClick={handleChosenTheme}
    >
      <div className={styles.titleCont}>
        <h3>{item.responseName}</h3>

        {item[id] === 8 && (
          <div className={`${styles.custom} ${styles.recommended}`}>
            <SvgWithBranding type="thumbsUp" /> <p>Recommended</p>
          </div>
        )}
        {isCustom && (
          <div className={`${styles.custom}`}>
            <SvgWithBranding type="custom" />
            <p>Custom</p>
          </div>
        )}
      </div>

      <div
        className={`${styles['subTitle-cont']} ${
          item?.tags?.length > 5 ? styles['hide'] : ''
        }`}
      >
        {item?.tags?.split(',').map((tag, index) => (
          <p key={index} className={styles['rounded-text']}>
            {tag.trim()}
          </p>
        ))}
      </div>

      <p>{item.description}</p>
      <h4>
        Example Response: <span>{item.exampleResponse}</span>
      </h4>
    </div>
  );
};

export default Card;
